import React from "react";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import PropTypes from "prop-types";

function InformarPagamentoModal({
  pagamentoModalHook,
  valuesHook,
  informarPagamentoButton,
  cancelarPagamento,
  efetuarPagamento,
}) {
  const { informarPagamentoModal, setInformarPagamentoModal } =
    pagamentoModalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Informar pagamento"
      is_open_modal={informarPagamentoModal}
      set_is_open_modal={setInformarPagamentoModal}
      size="md"
      buttons={
        informarPagamentoButton ? (
          <button
            key={`cancelar-pagamento`}
            type="button"
            onClick={cancelarPagamento}
            className="btn btn-info"
          >
            Cancelar pagamento
          </button>
        ) : (
          <button
            key={`efetuar-pagamento`}
            type="button"
            onClick={efetuarPagamento}
            className="btn btn-success"
          >
            Confirmar pagamento
          </button>
        )
      }
    >
      <div className="row">
        <div className="col-12 mb-3">
          <CommonInputValor
            label="Valor pago"
            id="valor_pago"
            value={values.valor_pago}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_pago",
                e.target.value,
                values,
                setValues
              );
            }}
          />
        </div>
        <div className="col-12 mb-3">
          <CommonInputDate
            label="Data do pagamento"
            id="data_pagamento"
            value={values.data_pagamento}
            onChange={(e) => handleChange(e, values, setValues)}
          />
        </div>
      </div>
    </CommonModal>
  );
}

InformarPagamentoModal.propTypes = {
  pagamentoModalHook: PropTypes.shape({
    informarPagamentoModal: PropTypes.bool.isRequired,
    setInformarPagamentoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  informarPagamentoButton: PropTypes.bool.isRequired,
  cancelarPagamento: PropTypes.func.isRequired,
  efetuarPagamento: PropTypes.func.isRequired,
};

export default InformarPagamentoModal;
